module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/store_images/4@2x_39ed1ea40d2cc91b47e6eab2fbc6cf8d.png";